module.exports = __webpack_public_path__ + "img/github-circle-white-48px.cf33952.svg";